export const ChatbotId = 'vOM92rzYeWvrKt_cFYW1u';
